var map = {
	"./book-s.png": 1662,
	"./book.png": 524,
	"./class-s.png": 1663,
	"./class.png": 525,
	"./coin-s.png": 1664,
	"./coin.png": 526,
	"./donation-s.png": 1665,
	"./donation.png": 1666,
	"./invite-s.png": 1667,
	"./invite.png": 1668,
	"./money-s.png": 1669,
	"./money.png": 1670,
	"./reading-off.png": 1671,
	"./reading-s.png": 1672,
	"./reading.png": 1673,
	"./reviews.png": 1674,
	"./school-s.png": 1675,
	"./school.png": 1676,
	"./student-s.png": 1677,
	"./student.png": 1678,
	"./writing-s.png": 1679,
	"./writing.png": 1680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 668;



//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons .\.png*
// module id = 668
// module chunks = 0